import React from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { LoginPage, GardenSetupPage } from './pages/LoginPage';
import { MapPage } from './pages/MapPage';

function AppInner() {
  const { user, garden, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-garden-50 dark:bg-gray-950">
        <div className="flex flex-col items-center gap-3">
          <span className="text-4xl animate-bounce" aria-hidden="true">🌿</span>
          <p className="text-garden-600 dark:text-garden-400 font-medium text-sm">Loading GardenMap…</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;
  if (!garden) return <GardenSetupPage />;
  return <MapPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
